/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./ZhSupportHK.css";
import { Link } from "react-router-dom";
import HomepageMenuZh from "../../assets/component/HomepageMenuZh/HomepageMenuZh.js";

class ZhSupportHK extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    return (
      <div className="ZhSupportHK-view">
        {!!this.state.showModal && (
          <HomepageMenuZh closeModal={this.closeModal} />
        )}
        <div className="ZhSupportHK-section">
          <Link to="/Zh">
            <div className="ZhSupportHK-back">
              <div className="ZhSupportHK-backBtn"></div>
              <div className="ZhSupportHK-backText">返回</div>
            </div>
          </Link>
          <div className="ZhSupportHK-logo" />
          <div className="ZhSupportHK-title">
            與香港同行
            <br />
            齊心抗疫
          </div>

          <div className="ZhSupportHK-outerContainer">
            <div className="ZhSupportHK-container">
              <a
                href="https://peacemaker.check.plus/MissionDetails?no=55"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="ZhSupportHK-description">緊急支援基層基金</div>
                <div className="ZhSupportHK-QR1" />
              </a>
            </div>

            <div className="ZhSupportHK-container2">
              <a
                href="https://sunrisechurch.check.plus/MissionDetails?no=90"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="ZhSupportHK-description">防疫基金</div>
                <div className="ZhSupportHK-QR2" />
              </a>
            </div>

            <div className="ZhSupportHK-container">
              <a
                href="https://lovefoundation.check.plus/MissionDetails?no=89"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="ZhSupportHK-description">以愛同行 抗疫捐贈</div>
                <div className="ZhSupportHK-QR3" />
              </a>
            </div>
          </div>
        </div>

        <div className="ZhSupportHK-footer">
          <div className="ZhSupportHK-footerNav">
            <Link to="/ZhTeam">
              <div className="ZhSupportHK-footerNavItem">創辦人的故事</div>
            </Link>
            <Link to="/ZhFaq">
              <div className="ZhSupportHK-footerNavItem">常見問題</div>
            </Link>
            <Link to="/ZhContact">
              <div className="ZhSupportHK-footerNavItem">聯絡我們</div>
            </Link>
          </div>

          <div className="ZhSupportHK-footer_text">
            香港九龍油塘四山街 11 號
            <br />
            華利工業大廈 5 樓 A 室
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. 保留一切權利。
          </div>
        </div>
      </div>
    );
  }
}

export default ZhSupportHK;
